import { Cell, List } from '@vkontakte/vkui';
import { Image as VkImage } from '@vkontakte/vkui/dist/components/Image/Image';
import bridge from '@vkontakte/vk-bridge';
import * as Sentry from '@sentry/browser';
import PropTypes from 'prop-types';
import { useAppContext } from '../../AppContext';
import ImageViewer from 'react-simple-image-viewer';
import React from 'react';

const SelectImagesDeleteComponentVk = ({value, setValue}) => {
  return (<List>
    {
      value.map((img, imgIndex) => (
        <Cell
          key={img.id}
          mode="removable"
          before={
            <VkImage
              mode="app"
              size={42}
              src={img.src_s}
              onClick={() => {
                bridge.send('VKWebAppShowImages', {
                    images: value.map((img) => img.src),
                    start_index: imgIndex,
                  })
                  .then((data) => {
                    Sentry.captureMessage(JSON.stringify(data));
                  })
                  .catch((error) => {
                    Sentry.captureMessage(JSON.stringify(error));
                    console.error(error);
                  });
              }}
            />
          }
          onRemove={() => {
            value.splice(imgIndex, 1);
            setValue([...value]);
          }}
        >
          {img.name}
        </Cell>
      ))
    }
  </List>);
}

const SelectImagesDeleteComponentTelegram = ({value, setValue}) => {
  const [show, setShow] = React.useState(false);
  const [curItem, setCurItem] = React.useState(0);

  return (<>
    {
      show && (<ImageViewer
        src={value.map((img) => img.src)}
        currentIndex={curItem}
        onClose={() => {
          setShow(false);
          setCurItem(0);
        }}
        disableScroll={false}
        backgroundStyle={{
          backgroundColor: 'rgba(0,0,0,0.9)',
          top: 'var(--vkui--size_panel_header_height--regular)',
        }}
        closeOnClickOutside={true}
      />)
    }
    <List>
      {
        value.map((img, imgIndex) => (
          <Cell
            key={img.id}
            mode="removable"
            before={
              <VkImage
                mode="app"
                size={42}
                src={img.src_s}
                onClick={() => {
                  setCurItem(imgIndex);
                  setShow(true);
                }}
              />
            }
            onRemove={() => {
              value.splice(imgIndex, 1);
              setValue([...value]);
            }}
          >
            {img.name}
          </Cell>
        ))
      }
    </List>
  </>);
}

export const SelectImagesDeleteComponent = (props) => {
  const context = useAppContext();

  switch (context.platform) {
    case 'vk':
      return (<SelectImagesDeleteComponentVk {...props} />);
    case 'telegram':
      return (<SelectImagesDeleteComponentTelegram {...props} />);
  }

  return (<></>);
}

const image = PropTypes.shape({
  id: PropTypes.number.isRequired,
  name: PropTypes.string.isRequired,
  src: PropTypes.string.isRequired,
  src_s: PropTypes.string.isRequired,
});

SelectImagesDeleteComponent.protoType = {
  panel: PropTypes.string.isRequired,
  images: PropTypes.arrayOf(image.isRequired).isRequired,
  value: PropTypes.arrayOf(PropTypes.number.isRequired).isRequired,
  setValue: PropTypes.func.isRequired,
  checkboxLabel: PropTypes.string,
}
